import cookie from 'vue-cookies'
const view = {
    state: {
        isLoading: false,
        maskShow: false,
        headerShow: true,
        footerShow: true,
        newRouter: cookie.get('menu')
    },
    mutations: {
        showLoading(state) {
            state.isLoading = true
        },
        hideLoading(state) {
            state.isLoading = false
        },
        showMask(state) {
            state.maskShow = true
            document.body.style.overflow = 'hidden'
        },
        hideMask(state) {
            state.maskShow = false
            document.body.style.overflow = 'auto'
        },
        setNewRouter(state,newRouter) {
            state.newRouter = newRouter
        },
        showHeader(state) {
            state.headerShow = true
        },
        showFooter(state) {
            state.footerShow = true
        },
        hideHeader(state) {
            state.headerShow = false
        },
        hideFooter(state) {
            state.footerShow = false
        }
    }
}

export default view;